export const genreTypes = {
  FIND_ALL: 'genre_find_all',
};
